import React from 'react';

interface Props {
  title?: string;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

const DashboardContainer = ({ title, children, className, titleClassName, contentClassName }: Props) => {
  return (
    <div
      className={`mt-6 w-full rounded-2xl border border-slate-200 bg-white shadow-sm ${
        className ? className : ''
      }`}
    >
      {title && (
        <span
          className={`block w-full border-b border-slate-100 px-5 py-4 text-sm font-semibold text-slate-800 ${
            titleClassName ? titleClassName : ''
          }`}
        >
          {title}
        </span>
      )}
      <div className={`flex flex-col gap-4 px-5 py-5 ${contentClassName ? contentClassName : ''}`}>
        {children}
      </div>
    </div>
  );
};

export { DashboardContainer };
